import { useTranslation } from 'next-i18next'

import ROUTES from '~/shared/constants/routes.const'
import useItemsSettings from '~/study-tips/hooks/useItemsSettings'
import { BlockContent } from '~/components/BlockContent'
import TipsButton from '~/components/Buttons/TipsButton'
import { TipsItemKey } from '~/study-tips/types/studyTips.types'
import { studytipsItemList } from '~/shared/types/studyTips.types'
import { BackButton } from '~/components/Buttons/BackButton'

const WRAPPER_STYLE = {
  backgroundSize: '42.5%',
}

const StudyTipsItemPage = ({
  itemData,
  itemKey,
}: {
  itemData: studytipsItemList
  itemKey: string
}): React.ReactElement => {
  const itemSetting = useItemsSettings(itemKey as TipsItemKey)

  const itemsList = itemData.items?.map((item) => (
    <div className={`w-full md:pr-4 pb-4 ${itemSetting.itemClass}`} key={item.id}>
      <TipsButton icon={item.icon} path={`${ROUTES.STUDY_TIPS}/${itemKey}/${item.id}`} title={item.name} />
    </div>
  ))

  const { t } = useTranslation('studyTips')

  return (
    <div className="min-h-screen  py-8 px-4 lg:px-8 sm:px-16" style={WRAPPER_STYLE}>
      <BackButton href={ROUTES.STUDY_TIPS} pageTitle={t('title')} />

      <section className="max-w-max mx-auto">
        <h1 className="text-h3 font-normal leading-9 mb-8 text-center text-white">{itemData.name}</h1>

        <section className="gradient-border-container rounded lg:max-w-2xl mb-8 shadow-card mx-auto">
          <div className="bg-white rounded p-4 leading-7">
            <BlockContent blocks={itemData.intro || []} />
          </div>
        </section>

        <div className="lg:max-w-[840px] flex flex-wrap items-center justify-center md:-mr-4 lg:mr-0">{itemsList}</div>
      </section>
    </div>
  )
}

export default StudyTipsItemPage
